if (!!document.querySelector('.ia-block-product-filters')) {
    let timer
    let time = 0
    let focused
    function hasQueryParams(url) {
        return url.includes('?');
    }
    if (hasQueryParams(document.URL)) {
        window.addEventListener("load", () => {
            if (document.querySelector('.woocommerce-before-loop') === null) {
                return
            }
            window.scrollTo({
                top: document.querySelector('.ia-block-product-filters').offsetTop - 100,
                left: 0 ,
                behavior: 'smooth',
            })
        });
    }
    document.querySelectorAll('.ia-block-product-filters').forEach(block => {
        filters = {}

        document.querySelectorAll('.ia-block-product-filters select, input[type=range]').forEach(input => {
            input.addEventListener('change', e => {
                submitFilters()
                // if (timer != undefined) {
                //     clearInterval(timer)
                //     time = 0
                // }
                // if (focused == undefined || !focused) {
                //     setTimeout(submitFilters, 300)
                // }
            })

            input.addEventListener('focus', e => {
                focused = true
            })

            input.addEventListener('blur', e => {
                setTimeout(() => focused = false, 200)
            })
        })
        
        function submitFilters() {
            //timer = setInterval(() => {
                //time = time + 100
                //if (time === 500) {
                    block.querySelector('.ia-block-product-filters__inner-container').submit()
                    //clearInterval(time)
                //}
            //}, 100)
        }
    })

}

if (!!document.querySelector('.post-type-archive-product .woocommerce-pagination')) {
    let pageNumber = document.querySelector('.woocommerce-pagination #pageNumber')

    pageNumber.addEventListener('change', e => {
        // Update paged value
        document.querySelector('.ia-block-product-filters input[name="paged"]').value = e.target.value
        // Submit filters
        document.querySelector('.ia-block-product-filters__inner-container').submit()
    })
}